import React, { useState } from 'react';
import { IncomeExpensePageShell } from './components/IncomeExpensePageShell';
import DataImportTab from './components/DataImportTab';
import { DATA_IMPORT_TABS } from './tabConfigs';

const DataImportPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('revenue');

  return (
    <IncomeExpensePageShell
      pageTitle="Import dữ liệu"
      pageCode="IE_DATA_IMPORT"
      tabs={DATA_IMPORT_TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      {activeTab === 'revenue' && <DataImportTab importType="REVENUE" title="Khoản thu" />}
      {activeTab === 'expenditure' && <DataImportTab importType="EXPENDITURE" title="Khoản chi" />}
      {activeTab === 'revenue-plans' && <DataImportTab importType="REVENUE_PLAN" title="Dự toán thu" />}
    </IncomeExpensePageShell>
  );
};

export default DataImportPage;
